<template>
  <div id="app">
    <topBar :showTopBar='showTopBar'></topBar>
    <router-view>
    </router-view>
    <Footer :showFooter="showFooter"></Footer>
    <diandiFooter :showDiandiFooter='showDiandiFooter'></diandiFooter>
  </div>
</template>

<script>
import diandiFooter from "@/components/shares/diandiFooter"
import topBar from "@/components/shares/centerHeader"
import Footer from "@/components/shares/centerFooter"
import Cookie from 'js-cookie'
export default {
  name: 'App',
  components: {
    Footer,
    topBar,
    diandiFooter
  },
  data () {
    return {
      showTopBar: true,//是否展示顶部
      showFooter: true,//是否展示footer
      // indexLink:'聚优'
      showDiandiFooter: false
    }
  },
  mounted () {
    var movie_column = Cookie.get("movie-column");
    var channel = Cookie.get("channel");
    if (movie_column == 1 && channel == 2) {//显示聚优，展示footer
      this.showFooter = true
      this.showDiandiFooter = false
    } else if (movie_column == 0) {
      this.showFooter = false
      this.showDiandiFooter = false
      // this.indexLink = ''
    } else if (movie_column == 1 && channel == 1) {
      // this.indexLink = '点滴'
      this.showDiandiFooter = true
      this.showFooter = false
    }
    // 友盟统计添加
    const script = document.createElement("script");
    script.src =
      "https://v1.cnzz.com/z_stat.php?id=1280091449&web_id=1280091449";   //该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.language = "JavaScript";
    document.body.appendChild(script);
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue